<template>
  <AppAside>
    <p>
      Your name should be entered as it appears on your license or ID. If you have recently received a REAL ID,
      you should enter your middle name <!--or suffix--> as shown on the physical card.
    </p>
    <p>
      Either phone or e-mail is required. This information can be used to lookup your reservation. If you consent
      to receive confirmation and reminders you will receive confirmation upon completing your reservation and a
      reminder prior to your reservation date.
    </p>
    <p v-if="resTypeForCustomer && resTypeForCustomer.visitCategoryId == 7">The Notice ID is found in the top right corner of your Tax Verification Form.</p>
  </AppAside>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import AppAside from './AppAside.vue';

const store = useStore();
const resTypeForCustomer = computed(() => store.state.user.resTypeForCustomer);
</script>
